// Copyright 2017 Sorama B.V.

import { IPolyfill } from "overrides/polyfills/IPolyfill";

/*
 * Polyfill for the Number.parse<Float/Int> API. Adapted from: https://github.com/neovov/Fullscreen-API-Polyfill
 */
export class ParseNumberPolyfill implements IPolyfill {
    //#region IPolyfill Members
    public use(): IPolyfill {
        if (!Number.parseFloat) Number.parseFloat = parseFloat;

        if (!Number.parseInt) Number.parseInt = parseInt;

        return this;
    }
    //#endregion
}
